/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { Layer, Source } from 'react-map-gl';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TestPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    const polygonFeature: any = {
        type: 'Feature',
        properties: { id: 'poly1' },
        geometry: {
            type: 'Polygon',
            coordinates: [
                [
                    [10.752245, 59.913869], // Oslo, Norway
                    [18.068581, 59.329324], // Stockholm, Sweden
                    [24.753574, 59.436962], // Tallinn, Estonia
                    [21.012229, 52.229676], // Warsaw, Poland
                    [14.4378, 50.075538], // Prague, Czechia
                    [10.752245, 59.913869] // Close the polygon, Oslo, Norway
                ]
            ]
        }
    };

    const lineFeature: any = {
        type: 'Feature',
        properties: { id: 'line1' },
        geometry: {
            type: 'LineString',
            coordinates: [
                [12.496366, 41.902782], // Italy
                [23.727539, 37.98381], // Greece
                [30.5234, 50.4501] // Ukraine
            ]
        }
    };

    const iconFeature: any = {
        type: 'Feature',
        properties: {
            id: 'icon1',
            description: 'Custom Icon and Text'
        },
        geometry: {
            type: 'Point',
            coordinates: [23.727539, 37.98381] // Greece
        }
    };

    return (
        <S_TestPage className={props.className}>
            <CustomMapPage
                mapId={'11602503-ba6e-473a-96d4-7bbb32e4674b'}
                onMapLoaded={() => {
                    const map = ctxView.mapRef.current.getMap();
                    map.loadImage(
                        'https://upload.wikimedia.org/wikipedia/commons/f/fb/NTNU_Trondheim_Mainbuilding.jpg', // Replace with your custom image URL
                        (error, image) => {
                            if (error) throw error;
                            console.log('Image', image);
                            map.addImage('custom-icon', image, {
                                sdf: false,
                                pixelRatio: image.height / image.width
                            });
                        }
                    );
                    map.loadImage(
                        'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/440px-Image_created_with_a_mobile_phone.png', // Replace with your custom image URL
                        (error, image) => {
                            if (error) throw error;
                            map.addImage('custom-icon-2', image);
                        }
                    );
                }}
                mapChildren={
                    <>
                        {/* POLYGON */}
                        <Source id="polygon" type="geojson" data={polygonFeature}>
                            <Layer
                                id="polygonLayer"
                                type="fill"
                                source="polygon"
                                paint={{
                                    // 'fill-color': 'rgba(0,0,0,0.5)' //rgba
                                    'fill-opacity': 0.5,
                                    'fill-color': [
                                        'step',
                                        ['zoom'],
                                        '#3a8ee6', // Default color: blue
                                        7,
                                        '#e63a3a', // Red color at zoom level 7 and higher
                                        12,
                                        '#4be63a' // Green color at zoom level 12 and higher
                                    ]
                                }}
                                minzoom={3}
                                maxzoom={24}
                            />
                            <Layer
                                id="polygonOutlineLayer"
                                type="line"
                                source="polygon"
                                paint={{
                                    'line-color': 'rgba(0,255,0,0.5)',
                                    'line-width': 4,
                                    'line-offset': 0
                                }}
                            />
                        </Source>

                        {/* LINE */}
                        <Source id="line" type="geojson" data={lineFeature}>
                            <Layer
                                id="line1"
                                type="line"
                                source="line"
                                paint={{
                                    'line-color': '#FF0000',
                                    'line-width': 5,
                                    'line-opacity': 1,
                                    'line-dasharray': [1, 3] //first number line, second gap (somehow multiplied by width)
                                }}
                                layout={{
                                    'line-cap': 'round', // round, butt, square,
                                    'line-join': 'round' // round, bevel, miter
                                }}
                            />
                        </Source>

                        {/* POINT */}
                        <Source id="icon" type="geojson" data={iconFeature}>
                            <Layer
                                id="iconLayer-2"
                                type="symbol"
                                layout={{
                                    'icon-image': 'custom-icon',
                                    'icon-size': 0.1,
                                    'text-field': '{description}',
                                    'text-size': 12,
                                    'text-font': ['Open Sans Bold'],

                                    'icon-anchor': 'bottom'
                                    // 'icon-allow-overlap': true,
                                    // 'icon-ignore-placement': true,
                                    // 'text-transform': 'uppercase',
                                    // 'text-letter-spacing': 0.1,
                                    // 'text-anchor': 'top',
                                    // 'text-offset': [0, 0.5],
                                    // 'text-allow-overlap': true,
                                    // 'text-ignore-placement': true
                                }}
                                paint={{
                                    'text-color': '#000',
                                    'text-halo-color': '#fff',
                                    'text-halo-width': 1
                                }}
                            />
                        </Source>
                    </>
                }
            />
        </S_TestPage>
    );
};

const S_TestPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
